export const REQUEST_USER = 'REQUEST_USER';
export const SUCCESS_USER = 'SUCCESS_USER';
export const FAILURE_USER = 'FAILURE_USER';
export const CLEAR_USER = 'CLEAR_USER';
